import { Transform } from 'class-transformer';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { DateFilter } from '../../interfaces/filters/date.filter';
import { NotificationTypesEnum } from '../../enums';

export class NotificationsFilter implements PaginationFilter, DateFilter {
	@Transform(stringToBooleanNullable)
	isRead?: boolean;

	receiverId?: string;

	includeCommunityProfilesNotifications?: boolean;

	causeEntityId?: string;

	typeIds?: NotificationTypesEnum[];

	periodFrom?: Date;
	periodTo?: Date;

	pageSize?: number | null;
	page?: number | null;
}
